<template>
    <div>
        <b-modal :id="id" size="none">
            <template v-slot:modal-header="{ close }">
                <h3 class="w-100 text-center">{{ title }}</h3>
                <button type="button" class="close" @click="close()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">{{ __("close") }}</span>
                </button>
            </template>
            <template v-slot:default>
                <form
                    id="create-note-form"
                    :action="action"
                    method="post"
                    class="row form"
                >
                    <input type="hidden" name="_token" :value="csrf" />
                    <div
                        class="col-12 m-b-sm"
                        :class="hasError('title') ? 'has-error' : ''"
                    >
                        <input-wrapper
                            :label="__('note_title') + '*'"
                            type="text"
                            classNames="form-control "
                            name="note[title]"
                            v-model="note.title"
                            :errors="getErrors('title')"
                        />
                    </div>
                    <div
                        class="col-12"
                        :class="hasError('content') ? 'has-error' : ''"
                    >
                        <label> {{ __("content") }}* </label>
                        <textarea
                            class="form-control"
                            name="note[content]"
                            style="height:150px;"
                            v-model="note.content"
                        ></textarea>
                        <span
                            class="help-block text-danger"
                            v-if="hasError('content')"
                        >
                            {{ getError("content") }}
                        </span>
                    </div>
                </form>
            </template>
            <template v-slot:modal-footer>
                <button
                    type="button"
                    class="btn btn-white"
                    @click="closeModal()"
                >
                    {{ __("cancel") }}
                </button>
                <button
                    type="submit"
                    form="create-note-form"
                    class="btn btn-primary"
                >
                    {{ __("save") }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import InputWrapper from "../form/InputWrapper.vue";

export default {
    components: { InputWrapper },
    name: "modal-note-preview",

    data: () => ({
        csrf: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        note: {
            title: "",
            content: ""
        }
    }),
    props: {
        id: {
            type: String,
            default: "modal"
        },
        title: String,
        action: String,
        oldValues: Object,
        errors: Object
    },
    methods: {
        openModal() {
            this.$bvModal.show(this.id);
        },
        closeModal() {
            this.$bvModal.hide(this.id);
            this.clearErrors();
            this.note = {};
        },
        restoreOldValues() {
            this.note.title = this.oldValues.title;
            this.note.content = this.oldValues.content;
        },
        hasAnyError() {
            for (const [key, value] of Object.entries(this.errors)) {
                if (value.length > 0) {
                    return true;
                }
            }

            return false;
        },
        clearErrors() {
            for (const [key, value] of Object.entries(this.errors)) {
                this.errors[key] = [];
            }
        },
        hasError(inputName) {
            return (
                this.errors[inputName] != undefined &&
                this.errors[inputName].length > 0
            );
        },
        getError(inputName) {
            return this.errors[inputName] != undefined
                ? this.errors[inputName][0]
                : "";
        },
        getErrors(inputName) {
            return this.errors[inputName] != undefined
                ? this.errors[inputName]
                : [];
        }
    },
    mounted() {
        this.restoreOldValues();
        if (this.hasAnyError()) this.openModal();
    }
};
</script>
